"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Send_1 = __importDefault(require("@material-ui/icons/Send"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const ClickAwayListener_1 = __importDefault(require("@material-ui/core/ClickAwayListener"));
const chatFunctions = __importStar(require("../../domain/model/chats"));
const sendMessage_1 = __importDefault(require("../../actions/chats/sendMessage"));
const stateFunctions_1 = require("../../domain/stateFunctions");
const AttachFile_1 = __importDefault(require("./AttachFile"));
const SendCycles_1 = __importDefault(require("./SendCycles"));
const MessageTextInput_1 = __importDefault(require("./MessageTextInput"));
const CurrentUserTypingHandler_1 = __importDefault(require("../../domain/CurrentUserTypingHandler"));
const smiley_svg_1 = __importDefault(require("../../icons/smiley.svg"));
const dollar_svg_1 = __importDefault(require("../../icons/dollar.svg"));
const EmojiPicker_1 = __importDefault(require("./EmojiPicker"));
const CloseButton_1 = __importDefault(require("../shared/CloseButton"));
const DraftMediaMessage_1 = __importDefault(require("./DraftMediaMessage"));
const DraftFileMessage_1 = __importDefault(require("./DraftFileMessage"));
const ReplyToMessagePanel_1 = __importDefault(require("./ReplyToMessagePanel"));
const Alert_1 = require("../../components/modals/Alert");
exports.default = react_1.default.memo(Footer);
const useStyles = makeStyles_1.default((theme) => ({
    footer: {
        display: "flex",
        backgroundColor: theme.colors.footer.backgroundColor,
        flexDirection: "column",
    },
    container: {
        color: "#9b9b9b",
        padding: "11px 16px 11px 10px",
        display: "flex",
        alignItems: "center",
    },
    buttons: {
        display: "flex",
        alignItems: "center",
    },
    button: {
        borderRadius: "50%",
        height: 32,
        width: 32,
        padding: 0,
        marginRight: 6,
        cursor: "pointer",
        "&:hover,:focus": {
            backgroundColor: theme.colors.icon.hover,
        },
        "& svg": {
            verticalAlign: "middle",
            pointerEvents: "none",
            margin: 0,
            padding: 0,
            color: theme.colors.footer.iconColor,
        },
    },
    sendButton: {
        outline: 0,
        height: 25,
        border: 0,
        margin: 0,
        padding: 0,
        cursor: "pointer",
        alignSelf: "center",
        backgroundColor: "transparent",
        marginLeft: 20,
        color: "#9b9b9b",
    },
}));
var MessagePanelState;
(function (MessagePanelState) {
    MessagePanelState[MessagePanelState["Closed"] = 0] = "Closed";
    MessagePanelState[MessagePanelState["EmojiPicker"] = 1] = "EmojiPicker";
    MessagePanelState[MessagePanelState["SendCycles"] = 2] = "SendCycles";
    MessagePanelState[MessagePanelState["SendFile"] = 3] = "SendFile";
})(MessagePanelState || (MessagePanelState = {}));
function Footer() {
    const dispatch = react_redux_1.useDispatch();
    const [messagePanelState, setMessagePanel] = react_1.useState(MessagePanelState.Closed);
    const [textBoxText, setTextBoxText] = react_1.useState("");
    const sendCyclesRef = react_1.useRef(null);
    const textBoxRef = react_1.useRef(null);
    const chat = react_redux_1.useSelector((state) => stateFunctions_1.getSelectedChat(state.chatsState));
    // Hold draft (media) message
    const draftMessageContentRef = react_1.useRef(null);
    const scrollBottomOverride = react_1.useRef();
    const them = react_redux_1.useSelector((state) => chat != null && chatFunctions.isDirectChat(chat)
        ? stateFunctions_1.getUserSummary(chat.them, state.usersState.userDictionary)
        : null);
    if (chat === null) {
        return react_1.default.createElement("div", null);
    }
    react_1.useEffect(() => {
        if (messagePanelState !== MessagePanelState.Closed) {
            changeMessagePanel(MessagePanelState.Closed, true);
        }
    }, [chat.chatId]);
    function changeMessagePanel(state, retainScrollBottom) {
        if (state !== MessagePanelState.SendFile &&
            draftMessageContentRef.current) {
            if (draftMessageContentRef.current.kind === "media") {
                const blobUrl = draftMessageContentRef.current.blobUrl;
                setTimeout(() => {
                    URL.revokeObjectURL(blobUrl);
                }, 100);
            }
            draftMessageContentRef.current = null;
        }
        if (state === MessagePanelState.Closed) {
            textBoxRef.current.onFocusBack();
        }
        if (retainScrollBottom) {
            const [_, scrollBottom] = chatFunctions.getScrollTopAndBottom();
            scrollBottomOverride.current = scrollBottom;
        }
        setMessagePanel(state);
    }
    react_1.useLayoutEffect(() => {
        if (scrollBottomOverride.current != null) {
            const messagesDiv = document.getElementById("messages");
            messagesDiv.scrollTop =
                messagesDiv.scrollHeight -
                    messagesDiv.clientHeight -
                    scrollBottomOverride.current;
            scrollBottomOverride.current = undefined;
        }
    });
    function onSendMessage() {
        let draftMessage = null;
        switch (messagePanelState) {
            case MessagePanelState.SendCycles:
                if (sendCyclesRef.current) {
                    draftMessage = {
                        kind: "cycles",
                        amount: sendCyclesRef.current.getCycles(),
                        caption: textBoxText,
                    };
                }
                break;
            case MessagePanelState.SendFile:
                if (draftMessageContentRef.current &&
                    (draftMessageContentRef.current.kind === "media" ||
                        draftMessageContentRef.current.kind === "file")) {
                    draftMessage = Object.assign(Object.assign({}, draftMessageContentRef.current), { caption: textBoxText });
                }
                break;
            default:
                if (textBoxText) {
                    draftMessage = { kind: "text", text: textBoxText };
                }
                break;
        }
        if (draftMessage) {
            switch (draftMessage.kind) {
                case "text":
                    if (draftMessage.text.length > 5000) {
                        Alert_1.alertDialog({
                            title: "Text too long",
                            text: "Messages are limited to 5000 characters",
                        });
                        return;
                    }
                    break;
                default:
                    if (draftMessage.caption && draftMessage.caption.length > 500) {
                        Alert_1.alertDialog({
                            title: "Text too long",
                            text: "Captions are limited to 500 characters",
                        });
                        return;
                    }
                    break;
            }
            dispatch(sendMessage_1.default(chat, draftMessage, chat.replyContext));
            changeMessagePanel(MessagePanelState.Closed, false);
            textBoxRef.current.clearText();
        }
    }
    function onFileAttached(content) {
        if (content.kind === "file") {
            dispatch(sendMessage_1.default(chat, content, chat.replyContext));
            textBoxRef.current.clearText();
        }
        else {
            draftMessageContentRef.current = content;
            changeMessagePanel(MessagePanelState.SendFile, true);
        }
    }
    function onFileValidationError(error, mimeType) {
        let title;
        let type;
        let size;
        // TODO: derive size text from constants
        if (mimeType.startsWith("image/")) {
            title = "Image too big";
            type = "images";
            size = "1 Mb";
        }
        else if (mimeType.startsWith("video/")) {
            title = "Video too big";
            type = "videos";
            size = "5 Mb";
        }
        else {
            title = "File too big";
            type = "files";
            size = "1 Mb";
        }
        let text = `You are limited to ${type} of size ${size}`;
        Alert_1.alertDialog({ title, text });
    }
    function onTextChanged(text) {
        setTextBoxText(text);
        if (chat && chatFunctions.isConfirmedChat(chat)) {
            CurrentUserTypingHandler_1.default.markTyping(chat.chatId);
        }
    }
    const classes = useStyles();
    let messagePanel = null;
    switch (messagePanelState) {
        case MessagePanelState.EmojiPicker:
            messagePanel = (react_1.default.createElement(EmojiPicker_1.default, { onEmojiSelected: textBoxRef.current.insertEmoji }));
            break;
        case MessagePanelState.SendCycles:
            if (chatFunctions.isDirectChat(chat)) {
                messagePanel = react_1.default.createElement(SendCycles_1.default, { ref: sendCyclesRef, recipient: them });
            }
            break;
        case MessagePanelState.SendFile:
            if (draftMessageContentRef.current) {
                if (draftMessageContentRef.current.kind === "media") {
                    const draft = draftMessageContentRef.current;
                    messagePanel = (react_1.default.createElement(DraftMediaMessage_1.default, { blobUrl: draft.blobUrl, width: draft.width, height: draft.height, mimeType: draft.mimeType }));
                }
                else if (draftMessageContentRef.current.kind === "file") {
                    const draft = draftMessageContentRef.current;
                    messagePanel = (react_1.default.createElement(DraftFileMessage_1.default, { name: draft.name, size: draft.data.length, mimeType: draft.mimeType }));
                }
            }
            break;
    }
    const closeButton = (react_1.default.createElement(CloseButton_1.default, { onClick: () => changeMessagePanel(MessagePanelState.Closed, true), className: classes.button }));
    return (react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: () => { var _a; return (_a = textBoxRef.current) === null || _a === void 0 ? void 0 : _a.onFocusAway(); } },
        react_1.default.createElement("footer", { className: classes.footer },
            react_1.default.createElement(ReplyToMessagePanel_1.default, null),
            messagePanel,
            react_1.default.createElement("div", { className: classes.container },
                react_1.default.createElement("div", { className: classes.buttons },
                    messagePanelState !== MessagePanelState.EmojiPicker ? (react_1.default.createElement(IconButton_1.default, { onClick: (_) => changeMessagePanel(MessagePanelState.EmojiPicker, true), className: classes.button },
                        react_1.default.createElement(smiley_svg_1.default, null))) : (closeButton),
                    messagePanelState != MessagePanelState.SendFile ? (react_1.default.createElement(AttachFile_1.default, { onFileSelected: onFileAttached, onFileValidationError: onFileValidationError, className: classes.button })) : (closeButton),
                    them && messagePanelState !== MessagePanelState.SendCycles ? (react_1.default.createElement(IconButton_1.default, { className: classes.button, onClick: (_) => changeMessagePanel(MessagePanelState.SendCycles, true) },
                        react_1.default.createElement(dollar_svg_1.default, null))) : them ? (closeButton) : null),
                react_1.default.createElement(MessageTextInput_1.default, { ref: textBoxRef, placeholder: messagePanelState === MessagePanelState.Closed ||
                        messagePanelState === MessagePanelState.EmojiPicker
                        ? "Type a message"
                        : "Type a caption", onEnterPressed: onSendMessage, onChange: onTextChanged }),
                react_1.default.createElement("button", { onClick: onSendMessage, className: classes.sendButton },
                    react_1.default.createElement(Send_1.default, null))))));
}
